import React from 'react'
import { Modal, ModalHeader, Media, ModalBody, ModalFooter, Col, Button, Row, Label } from 'reactstrap';
import { Dialog } from 'primereact/dialog';

export const ModalConfirmReleaseAll = (props) => {

    const {
        modalRelease, toggleRelease, loadingRelease, releaseAll, closeDialogRelease
    } = props;

    return (
         <Dialog 
                header={'Liberar Estudios'}
                visible={modalRelease}
                onHide={closeDialogRelease}
                closable={true}
                modal
                blockScroll
                className='tiny-dialog'
            >
       
            <ModalBody>
                <Label>
                    Al aceptar, esta acción va a <strong>LIBERAR</strong> todos los estudios que ya se encuentren validados.
                </Label>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" type="button" onClick={() => releaseAll()} size="sm" disabled={loadingRelease} className={loadingRelease ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    Aceptar, liberar todo
                </Button>
                <Button size="sm" color='danger' type="button" onClick={closeDialogRelease}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Dialog>
    )
}
